module.exports = __webpack_public_path__ + "img/green-square.37939824.png";